import { MuiF } from '../../../../../Mui/F/Function/module/MuiF.js';

export const handleBlankPlateClick = () => MuiF.closeFrame();
